








































import { defineComponent, ref } from "@vue/composition-api";
import { VaultFileUsageSubjectTypeEnum } from "@scrile/api-provider/dist/api/VaultsProvider";
import { getDuration, getVideoDuration } from "@/hooks/useAttachmentFilesInfo";
import useVaultView from "@/hooks/useVaultView";
import emitter from "@/lib/emitter";
import { getNameMimeType, isAttachmentFile } from "@/lib/fileHelpers";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { AttachmentFile, NotificationData } from "@/types";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseInputFileWithPreview from "@/components/BaseInputFileWithPreview";
import VaultModal from "@/components/VaultModal";

const minDurationText = $t("Videos have to be at least {0} minutes long", [config.postMainVideoMinDurationMs / 60000]);

export default defineComponent({
  name: "AddMainVideo",
  components: {
    VaultModal,
    BaseInputFileWithPreview,
    BaseButton,
  },
  setup(props, { emit }) {
    const { showPrivateVault: showVault, showVaultOrNative } = useVaultView();

    const loading = ref(false);

    const postSubject = {
      subjectId: "0",
      subjectType: VaultFileUsageSubjectTypeEnum.USER_CONTENT_SETS,
    };

    const emitNotification = (text: string) =>
      emitter.emit<NotificationData>(EVENTS.NOTIFICATION_SHOW, {
        text,
      });

    const onAddFiles = async (files: Array<AttachmentFile | File>) => {
      try {
        loading.value = true;
        const options: { publicAccess: boolean; cb: () => void; validatedMediaType?: string } = {
          publicAccess: false,
          cb: () => (loading.value = false),
        };
        if (files.every(isAttachmentFile)) {
          if (files.every(i => getDuration(i) < config.postMainVideoMinDurationMs)) {
            emitNotification(minDurationText);
            return;
          }
          emit("addFilesFromVault", files, options);
        } else {
          if (files.every(f => f instanceof File)) {
            const durations = await Promise.all(files.map(f => getVideoDuration(f as File)));
            if (durations.some(i => i < config.postMainVideoMinDurationMs / 1000)) {
              emitNotification(minDurationText);
              return;
            }
            if (files.length) {
              const file = files[0] as File;
              options.validatedMediaType = file.type.startsWith("video") ? file.type : getNameMimeType(file.name);
            }
          }
          emit("addFiles", files, options);
        }
      } catch (e) {
        if ("message" in (e as Error)) emitNotification((e as Error).message);
      } finally {
        loading.value = false;
      }
    };

    const onNativeAddFileHandler = (files: FileList) => {
      onAddFiles(Array.from(files));
    };

    return {
      loading,
      showVault,
      postSubject,
      showVaultOrNative,
      onNativeAddFileHandler,
      onAddFiles,
    };
  },
});
